<script>
import { validationMixin } from 'vuelidate'
import { requiredIf } from 'vuelidate/lib/validators'
import { validationStatus } from '@/enums/validationStatus'
import { OrderStatus } from '@/enums/OrderStatus'
export default {
  mixins: [validationMixin],
  props: {
    defaults: { type: Object },
    hideSelectDocumentStatus: { type: Boolean },
    hideSelectOrderStatus: { type: Boolean },
    filteredOrdersCount: { type: Number },
    totalOrdersCount: { type: Number }
  },
  validations: {
    selectedDataSource: {
      required: requiredIf(function () {
        return this.filterDataSource
      })
    },
    selectedDocumentStatus: {
      required: requiredIf(function () {
        return this.filterDocumentStatus
      })
    },
    selectedOrderStatus: {
      required: requiredIf(function () {
        return this.filterOrderStatus
      })
    }
  },
  data: vm => ({
    dialog: false,
    filterDate: true,
    filterDataSource: false,
    filterDocumentStatus: false,
    filterOrderStatus: false,
    dateFrom: new Date(new Date() - 7 * 86400000).toISOString().substr(0, 10),
    dateTo: new Date().toISOString().substr(0, 10),
    menuFrom: false,
    menuTo: false,
    dataSource: [
      vm.$t('global.website'),
      vm.$t('component.orders.ordersFilter.datasource.sftp')
    ],
    documentStatus: [
      {
        value: validationStatus.userActionRequired,
        text: vm.$t('global.action.required')},
      {
        value: validationStatus.success,
        text: vm.$t('global.successful')
      },
      {
        value: validationStatus.error,
        text: vm.$t('global.failed')
      }
    ],
    orderStatus: [
      {
        value: OrderStatus.open,
        text: vm.$t('global.open')
      },
      {
        value: OrderStatus.pending,
        text: vm.$t('global.pending')
      },
      {
        value: OrderStatus.userActionRequired,
        text: vm.$t('global.action.required')
      },
      {
        value: OrderStatus.validated,
        text: vm.$t('component.orders.ordersTable.status.validated')
      },
      {
        value: OrderStatus.autocomplete,
        text: vm.$t('component.orders.ordersTable.status.autocomplete')
      },
      {
        value: OrderStatus.validationError,
        text: vm.$t('component.orders.ordersTable.status.validationError')
      },
      {
        value: OrderStatus.paymentOpen,
        text: vm.$t('component.orders.ordersTable.status.paymentOpen')
      },
      {
        value: OrderStatus.paymentPending,
        text: vm.$t('component.orders.ordersTable.status.paymentPending')
      },
      {
        value: OrderStatus.paymentRefused,
        text: vm.$t('component.orders.ordersTable.status.paymentRefused')
      }
    ],
    selectedDataSource: '',
    selectedDocumentStatus: '',
    selectedOrderStatus: '',
    savedFilterRules: {}
  }),
  computed: {
    selectedDataSourceErrors() {
      const errors = []
      if (!this.$v.selectedDataSource.$dirty) return errors
      !this.$v.selectedDataSource.required &&
        errors.push(this.$t('validation.field.required'))
      return errors
    },
    selectedDocumentStatusErrors() {
      const errors = []
      if (!this.$v.selectedDocumentStatus.$dirty) return errors
      !this.$v.selectedDocumentStatus.required &&
        errors.push(this.$t('validation.field.required'))
      return errors
    },
    selectedOrderStatusErrors() {
      const errors = []
      if (!this.$v.selectedOrderStatus.$dirty) return errors
      !this.$v.selectedOrderStatus.required &&
        errors.push(this.$t('validation.field.required'))
      return errors
    },
    computedDateFromFormatted() {
      return this.formatDate(this.dateFrom)
    },
    computedDateToFormatted() {
      return this.formatDate(this.dateTo)
    }
  },
  created: function () {
    // if defaults are set from parent, assign it
    if (this.defaults) {
      this.filterDate = this.defaults.filterDate
      this.dateFrom = this.defaults.dateFrom
      this.dateTo = this.defaults.dateTo
    }
    this.savedFilterRules = {
      filterDate: this.filterDate,
      filterDataSource: this.filterDataSource,
      filterDocumentStatus: this.filterDocumentStatus,
      filterOrderStatus: this.filterOrderStatus,
      dateFrom: this.dateFrom,
      dateTo: this.dateTo,
      selectedDataSource: this.selectedDataSource,
      selectedDocumentStatus: this.selectedDocumentStatus,
      selectedOrderStatus: this.selectedOrderStatus
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return ''
      const [year1, month1, day1] = date.toString().split('-')
      return `${day1}.${month1}.${year1}`
    },
    // save data
    save() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.savedFilterRules.filterDate = this.filterDate
        this.savedFilterRules.filterDataSource = this.filterDataSource
        this.savedFilterRules.filterDocumentStatus = this.filterDocumentStatus
        this.savedFilterRules.filterOrderStatus = this.filterOrderStatus
        this.savedFilterRules.dateFrom = this.dateFrom
        this.savedFilterRules.dateTo = this.dateTo
        this.savedFilterRules.selectedDataSource = this.selectedDataSource
        this.savedFilterRules.selectedDocumentStatus =
          this.selectedDocumentStatus
        this.savedFilterRules.selectedOrderStatus = this.selectedOrderStatus
        this.dialog = false
        this.$emit('update:savedFilterRules', this.savedFilterRules)
      }
    },
    // restore data when user canceled the dialog
    cancel() {
      this.filterDate = this.savedFilterRules.filterDate
      this.filterDataSource = this.savedFilterRules.filterDataSource
      this.filterDocumentStatus = this.savedFilterRules.filterDocumentStatus
      this.filterOrderStatus = this.savedFilterRules.filterOrderStatus
      this.dateFrom = this.savedFilterRules.dateFrom
      this.dateTo = this.savedFilterRules.dateTo
      this.selectedDataSource = this.savedFilterRules.selectedDataSource
      this.selectedDocumentStatus = this.savedFilterRules.selectedDocumentStatus
      this.selectedOrderStatus = this.savedFilterRules.selectedOrderStatus
      this.dialog = false
    },
    // delete / reset from saved and local data
    deleteFilter(filterDataProp, selectedDataProp) {
      this.savedFilterRules[filterDataProp] = false
      this[filterDataProp] = false
      if (selectedDataProp) {
        this.savedFilterRules[selectedDataProp] = ''
        this[selectedDataProp] = ''
      }
      this.$emit('update:savedFilterRules', this.savedFilterRules)
    }
  }
}
</script>
<template>
  <v-row class="ml-4">
    <v-col cols="auto">
      <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition">
        <template #activator="{ on, attrs }">
          <v-btn
            small
            elevation="2"
            color="primary"
            dark
            v-bind="attrs"
            block
            class="mt-1"
            v-on="on" >
            {{ $t('button.filter') }}
            {{ filteredOrdersCount }} / {{ totalOrdersCount }}
          </v-btn>
        </template>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="cancel">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{$t('global.filter') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ $t('component.orders.ordersFilter.info.text') }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ $t('component.orders.ordersFilter.info.sub.text') }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-card-text :class="$vuetify.breakpoint.smAndDown ? 'pl-0' : ''">
            <v-row>
              <v-col cols="12" class="pb-0">
                <v-list three-line subheader>
                  <v-list-item>
                    <v-list-item-action>
                      <v-checkbox v-model="filterDate"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{$t('component.orders.ordersFilter.filter.date.header') }}</v-list-item-title>
                      <v-list-item-subtitle>{{$t('component.orders.ordersFilter.filter.date.sub.header')}}</v-list-item-subtitle>
                      <v-row>
                        <v-col cols="12" sm="4" md="3" lg="2">
                          <!-- Date From -->
                          <v-menu
                            v-model="menuFrom"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template #activator="{ on, attrs }">
                              <v-text-field
                                v-model="computedDateFromFormatted"
                                :label="$t('component.orders.ordersFilter.filter.date.from.label')"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateFrom"
                              locale="de-DE"
                              scrollable
                              :max="dateTo"
                              :first-day-of-week="1"
                              @input="menuFrom = false"
                              @change="filterDate = true"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4" md="3" lg="2">
                          <!-- Date To -->
                          <v-menu
                            v-model="menuTo"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto">
                            <template #activator="{ on, attrs }">
                              <v-text-field
                                v-model="computedDateToFormatted"
                                :label="$t('component.orders.ordersFilter.filter.date.to.label')"
                                prepend-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="dateTo"
                              locale="de-DE"
                              scrollable
                              :min="dateFrom"
                              :max="new Date().toISOString().substr(0, 10)"
                              :first-day-of-week="1"
                              @input="menuTo = false"
                              @change="filterDate = true"
                            ></v-date-picker>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-action>
                      <v-checkbox v-model="filterDataSource"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{
                          $t('global.source')
                        }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                          $t('component.orders.ordersFilter.filter.datasource.sub.header')
                        }}</v-list-item-subtitle>
                      <v-select
                        v-model="selectedDataSource"
                        :items="dataSource"
                        :label="$t('global.source')"
                        :error-messages="selectedDataSourceErrors"
                        dense
                        class="pt-3"
                        @input="$v.selectedDataSource.$touch()"
                        @blur="$v.selectedDataSource.$touch()"
                        @change="filterDataSource = true"
                      ></v-select>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="!hideSelectOrderStatus">
                    <v-list-item-action>
                      <v-checkbox v-model="filterOrderStatus"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>
                      {{ $t('component.orders.ordersFilter.filter.orderstatus.header') }}</v-list-item-title>
                      <v-list-item-subtitle>
                      {{ $t('component.orders.ordersFilter.filter.orderstatus.sub.header') }}</v-list-item-subtitle>
                      <v-select
                        ref="orderStatusSelection"
                        v-model="selectedOrderStatus"
                        :items="orderStatus"
                        :label="$t('component.orders.ordersFilter.filter.orderstatus.header')"
                        :error-messages="selectedOrderStatusErrors"
                        dense
                        chips
                        multiple
                        class="pt-3"
                        @input="$v.selectedOrderStatus.$touch()"
                        @blur="$v.selectedOrderStatus.$touch()"
                        @change="filterOrderStatus = true" >
                        <template #prepend-item>
                          <v-list-item
                            @click="$refs.orderStatusSelection.blur()" >
                            <v-list-item-action
                            ><v-icon>mdi-close</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>{{$t('button.close')}}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                          <v-divider></v-divider>
                        </template>
                        <template #append-item>
                          <v-divider></v-divider>
                          <v-list-item
                            @click="$refs.orderStatusSelection.blur()">
                            <v-list-item-action
                            ><v-icon>mdi-close</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title>{{$t('button.close')}}</v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-select>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="!hideSelectDocumentStatus">
                    <v-list-item-action>
                      <v-checkbox v-model="filterDocumentStatus"></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{
                          $t('component.orders.ordersFilter.filter.documentstatus.header')
                        }}</v-list-item-title>
                      <v-list-item-subtitle>{{
                          $t('component.orders.ordersFilter.filter.documentstatus.sub.header')
                        }}</v-list-item-subtitle>
                      <v-select
                        v-model="selectedDocumentStatus"
                        :items="documentStatus"
                        :label="$t('component.orders.ordersFilter.filter.documentstatus.label')"
                        :error-messages="selectedDocumentStatusErrors"
                        dense
                        class="pt-3"
                        @input="$v.selectedDocumentStatus.$touch()"
                        @blur="$v.selectedDocumentStatus.$touch()"
                        @change="filterDocumentStatus = true"
                      ></v-select>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <v-row class="text-center">
              <v-col class="pt-0 pb-0">
                <v-btn dark color="primary" @click="save">
                  {{ $t('button.save') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col>
      <v-chip
        v-if="savedFilterRules.filterDate"
        close
        close-icon="mdi-close-outline"
        label
        outlined
        class="mt-1 mr-1 ml-1"
        @click="dialog = true"
        @click:close="deleteFilter('filterDate')">
        {{ $t('global.date') }}:
        {{ computedDateFromFormatted }} - {{ computedDateToFormatted }}</v-chip>
      <v-chip
        v-if="savedFilterRules.filterDataSource"
        close
        close-icon="mdi-close-outline"
        label
        outlined
        class="mt-1 mr-1 ml-1"
        @click="dialog = true"
        @click:close="deleteFilter('filterDataSource', 'selectedDataSource')">
        {{ $t('global.source') }}:
        {{ selectedDataSource }}</v-chip>
      <v-chip
        v-if="savedFilterRules.filterDocumentStatus"
        close
        close-icon="mdi-close-outline"
        label
        outlined
        item-value="value"
        item-text="text"
        class="mt-1 mr-1 ml-1"
        @click="dialog = true"
        @click:close="
          deleteFilter('filterDocumentStatus', 'selectedDocumentStatus')">
        {{ $t('component.orders.ordersFilter.filter.documentstatus.label') }}:
        {{ documentStatus.find(status => status.value === selectedDocumentStatus).text }}</v-chip>
      <v-chip
        v-if="savedFilterRules.filterOrderStatus"
        close
        close-icon="mdi-close-outline"
        label
        outlined
        item-value="value"
        item-text="text"
        class="mt-1 mr-1 ml-1"
        @click="dialog = true"
        @click:close="deleteFilter('filterOrderStatus', 'selectedOrderStatus')">
        <span>{{ $t('component.orders.ordersFilter.filter.orderstatus.label') }}:&nbsp;</span>
        <v-chip
          v-for="item in selectedOrderStatus"
          :key="item.value"
          :ripple="false"
          class="mr-1"
          small>
          {{ orderStatus.find(status => status.value === item).text }}
        </v-chip>
      </v-chip>
    </v-col>
  </v-row>
</template>
